import {
  sortBy,
  removeNull,
  getLevelArray,
  normalizePersonQuery,
  resolvePersonFilterUid
} from '@/utils/handleData.js'

/** 后端 HGisClock.currentDate 需要 yyyy-MM-dd HH:mm:ss */
function normalizeClockDate(value) {
  if (value == null || value === '') return value
  const text = String(value).trim()
  if (/^\d{4}-\d{2}-\d{2}$/.test(text)) {
    return text + ' 12:00:00'
  }
  if (text.length >= 19 && text.charAt(10) === 'T') {
    return text.substring(0, 19).replace('T', ' ')
  }
  return text
}

function normalizeClockPayload(item) {
  if (!item || typeof item !== 'object') return item
  const next = Object.assign({}, item)
  if (next.currentDate != null && next.currentDate !== '') {
    next.currentDate = normalizeClockDate(next.currentDate)
  }
  return next
}

/**
 * 确认态查询机构：
 * - 考核视角（organUid 与主体不同）：按考核机构查人/机构是否已确认
 * - 否则按考勤主体机构
 */
function resolveConfOrgUid(qv, subjectOrgUid) {
  const query = qv || {}
  const assess = query.organUid || ''
  const subject = subjectOrgUid || ''
  if (assess && subject && String(assess) !== String(subject)) {
    return assess
  }
  return subject || assess || ''
}

function normalizeConfirmationCount(value) {
  let raw = value
  if (Array.isArray(raw)) raw = raw[0]
  if (raw && typeof raw === 'object') {
    raw =
      raw.count != null
        ? raw.count
        : raw.countNum != null
        ? raw.countNum
        : raw.confirmed != null
        ? raw.confirmed
        : raw.isConf != null
        ? raw.isConf
        : raw.value
  }
  if (raw === true) return 1
  const count = Number(raw)
  return !Number.isNaN(count) && count > 0 ? 1 : 0
}

export default {
  namespaced: true,
  state: {
    statisticsType: 'bidSection',
    attendanceIsSure: '未确认',
    orgAttendance: [], // 某机构某月每天考勤明细
    perAttendance: [], // 某人员某月每天考勤明细
    perMonthStatistics: {}, // 某人员某月考勤统计（退场办理等）
    perTotalStatistics: {}, // 某人员累计考勤统计（退场办理等）
    orgDayAttendance: [], // 项目标段某天劳务公司出勤情况
    orgDayAbsent: [] // 某机构某日缺勤人员
  },
  getters: {
    // 上方提示：无数据优先；有数据时展示该月是否已确认
    getTagData: (state) => {
      return function () {
        const list =
          state.statisticsType === 'person'
            ? state.perAttendance
            : state.orgAttendance
        const hasData =
          state.statisticsType === 'person'
            ? !!(list && list.length)
            : !!(list && list.some((row) => Number(row && row.shouldNum) > 0))
        if (!hasData) {
          return {
            tagInfo:
              '当前查询条件未查询到数据或查询失败，可能原因是查询的时间范围已经结束或尚未开始，请改变查询条件或查询无误后再次查询',
            tagType: 'danger',
            tagImg: ''
          }
        }
        if (
          state.statisticsType === 'laborCompany' ||
          state.statisticsType === 'organ' ||
          state.statisticsType === 'person'
        ) {
          if (state.attendanceIsSure === '已确认') {
            return {
              tagInfo: '该月考勤已确认，可导入覆盖',
              tagType: 'success',
              tagImg: ''
            }
          }
          return {
            tagInfo: '该月考勤尚未确认',
            tagType: 'warning',
            tagImg: ''
          }
        }
        return { tagInfo: '', tagType: '', tagImg: '' }
      }
    },
    // 获取考勤统计数据
    statistics: (state) => {
      var statistics = []
      if (state.statisticsType === 'person') {
        statistics = state.perAttendance
      } else {
        statistics = state.orgAttendance
      }
      return statistics
    },
    // 个人月考勤数据
    batchClockData: (state, getters) => {
      var batchClockData = []
      if (state.statisticsType === 'person') {
        batchClockData = JSON.parse(JSON.stringify(getters.statistics))
        batchClockData = batchClockData.filter((item) => {
          item.isClock = item.isSure !== '1' ? '缺勤' : '出勤'
          return item.isSure !== '1'
        })
      }
      return batchClockData
    },
    // 是否渲染该日考勤：个人有记录即渲染；机构仅应出勤人数>0（有人在场，自最早进场日起）
    getIsShould: (state, getters) => {
      return function (day) {
        for (var i = 0; i < getters.statistics.length; i++) {
          const row = getters.statistics[i]
          if (row.useDate !== day) continue
          if (state.statisticsType !== 'person') {
            return Number(row.shouldNum) > 0
          }
          return true
        }
        return false
      }
    },
    // 渲染出勤状态图标
    getAttendanceImg: (state, getters) => {
      return function (day) {
        var attendanceImg = ''
        if (state.statisticsType === 'person') {
          for (var i = 0; i < getters.statistics.length; i++) {
            if (getters.statistics[i].useDate === day) {
              if (getters.statistics[i].updateReason) {
                attendanceImg = require('@/assets/img/editAtt.png')
              } else if (
                !getters.statistics[i].updateReason &&
                getters.statistics[i].reissueCard
              ) {
                attendanceImg = require('@/assets/img/supplement.png')
              } else if (
                getters.statistics[i].isSure === '1' &&
                !getters.statistics[i].reissueCard &&
                !getters.statistics[i].updateReason
              ) {
                attendanceImg = require('@/assets/img/sure.png')
              } else if (
                getters.statistics[i].isSure !== '1' &&
                !getters.statistics[i].reissueCard &&
                !getters.statistics[i].updateReason
              ) {
                attendanceImg = require('@/assets/img/unsure.png')
              }
              break
            }
          }
        }
        return attendanceImg
      }
    },
    // 渲染出勤状态
    getAttendanceStatus: (state, getters) => {
      return function (day) {
        var attendanceStatus = ''
        if (state.statisticsType === 'person') {
          attendanceStatus = '缺勤'
          for (var i = 0; i < getters.statistics.length; i++) {
            if (getters.statistics[i].useDate === day) {
              if (String(getters.statistics[i].isSure) === '1') {
                attendanceStatus = '出勤'
              }
              break
            }
          }
        }
        return attendanceStatus
      }
    },
    // 渲染是否打卡状态
    getClockStatus: (state, getters) => {
      var clockStatus = {}
      if (state.statisticsType === 'person') {
        for (var i = 0; i < getters.statistics.length; i++) {
          clockStatus[getters.statistics[i].useDate] = false
          if (String(getters.statistics[i].isSure) === '1') {
            clockStatus[getters.statistics[i].useDate] = true
          }
        }
      }
      return clockStatus
    },
    // 渲染日出勤人数
    getActualNum: (state, getters) => {
      return function (day) {
        var actualNum = 0
        for (var i = 0; i < getters.statistics.length; i++) {
          if (getters.statistics[i].useDate === day) {
            if (getters.statistics[i].actualNum) {
              actualNum = getters.statistics[i].actualNum
            }
            break
          }
        }
        return actualNum
      }
    },
    // 渲染日出勤率
    getAttendance: (state, getters) => {
      return function (day) {
        var attendance = '0%'
        for (var i = 0; i < getters.statistics.length; i++) {
          if (getters.statistics[i].useDate === day) {
            if (
              getters.statistics[i].actualNum &&
              getters.statistics[i].shouldNum
            ) {
              attendance =
                (
                  (getters.statistics[i].actualNum /
                    getters.statistics[i].shouldNum) *
                  100
                ).toFixed(1) + '%'
            }
            break
          }
        }
        return attendance
      }
    },
    // 渲染出勤时间
    getClockTime: (state, getters) => {
      return function (day) {
        var clockTime = '无'
        for (var i = 0; i < getters.statistics.length; i++) {
          if (getters.statistics[i].useDate === day) {
            if (getters.statistics[i].clockTime) {
              clockTime = getters.statistics[i].clockTime
            }
            break
          }
        }
        return clockTime
      }
    },
    // 渲染出勤地点
    getClockPlace: (state, getters) => {
      return function (day) {
        var clockPlace = '无'
        for (var i = 0; i < getters.statistics.length; i++) {
          if (getters.statistics[i].useDate === day) {
            if (getters.statistics[i].place) {
              clockPlace = getters.statistics[i].place
            }
            break
          }
        }
        return clockPlace
      }
    },
    // 渲染修改原因
    getEditReason: (state, getters) => {
      return function (day) {
        var editReason = ''
        for (var i = 0; i < getters.statistics.length; i++) {
          if (getters.statistics[i].useDate === day) {
            if (getters.statistics[i].updateReason) {
              editReason = getters.statistics[i].updateReason
            }
            break
          }
        }
        return editReason
      }
    },
    // 渲染补卡原因
    getSupplementReason: (state, getters) => {
      return function (day) {
        var supplementReason = ''
        for (var i = 0; i < getters.statistics.length; i++) {
          if (getters.statistics[i].useDate === day) {
            if (getters.statistics[i].reissueCard) {
              supplementReason = getters.statistics[i].reissueCard
            }
            break
          }
        }
        return supplementReason
      }
    },
    attendanceMatters: (state, getters) => {
      var attendanceMatters = []
      if (state.statisticsType === 'person') {
        attendanceMatters = [
          {
            icon: 'el-icon-time',
            value: (day) => {
              return getters.getClockTime(day)
            },
            isShow: (day) => {
              return !getters.getEditReason(day) &&
                !getters.getSupplementReason(day)
                ? true
                : false
            }
          },
          {
            icon: 'el-icon-location-information',
            value: (day) => {
              return getters.getClockPlace(day)
            },
            isShow: (day) => {
              return !getters.getEditReason(day) &&
                !getters.getSupplementReason(day)
                ? true
                : false
            }
          },
          {
            label: '修改原因：',
            value: (day) => {
              return getters.getEditReason(day)
            },
            isShow: (day) => {
              return getters.getEditReason(day) ? true : false
            }
          },
          {
            label: '补卡原因：',
            value: (day) => {
              return getters.getSupplementReason(day)
            },
            isShow: (day) => {
              return !getters.getEditReason(day) &&
                getters.getSupplementReason(day)
                ? true
                : false
            }
          }
        ]
      } else if (state.statisticsType !== 'person') {
        attendanceMatters = [
          {
            label: '出勤人数',
            value: (day) => {
              return getters.getActualNum(day)
            }
          },
          {
            label: '出勤率',
            value: (day) => {
              return getters.getAttendance(day)
            }
          }
        ]
      }
      return attendanceMatters
    }
  },
  actions: {
    // 确认机构考勤数据：按当前机构作为考核机构，仅确认其考核范围内属于该考核机构的考勤
    async confirmAttendance({ rootState, dispatch }) {
      const isLabor = rootState.currentTab.label === '劳务考勤'
      const qv = isLabor
        ? rootState.queryValues.laborAttendance
        : rootState.queryValues.manageAttendance
      const subjectUid = isLabor ? qv.downVproUid : qv.upVproUid
      var data = {
        orgUid: resolveConfOrgUid(qv, subjectUid),
        date: (qv.monthTime || '') + '-01'
      }
      const res = await dispatch(
        'baseRequest',
        {
          method: 'GET',
          url: '/rule/agree/clock',
          data: data,
          msg: '确认考勤成功'
        },
        { root: true }
      )
      return res
    },
    // 查询机构某月考勤是否确认
    async getOrgAttendanceIsSure({ commit, dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        { method: 'GET', url: '/organize/isagree/clock', data: data },
        { root: true }
      )
      const isSure =
        res && res.data && res.data.isConf === '已确认' ? '已确认' : '未确认'
      commit(
        'baseSet',
        {
          module: 'attendance',
          key: 'attendanceIsSure',
          value: isSure
        },
        { root: true }
      )
      return res
    },
    // 批量导入考勤
    async upLoadAttendance({ dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'PUT',
          url: '/act/clock/agreeedit',
          data: data,
          msg: '导入考勤成功'
        },
        { root: true }
      )
      return res
    },
    // 后台新增打卡
    async addAttendance({ dispatch }, data) {
      const payload = normalizeClockPayload(data)
      const res = await dispatch(
        'baseRequest',
        {
          method: 'POST',
          url: '/act/clock/webpunch',
          data: payload,
          msg: payload.msg ? payload.msg : '考勤打卡成功'
        },
        { root: true }
      )
      return res
    },
    // 后台批量新增打卡
    async batchAddAttendance({ dispatch }, data) {
      const list = Array.isArray(data)
        ? data.map((item) => normalizeClockPayload(item))
        : []
      const res = await dispatch(
        'baseRequest',
        {
          method: 'POST',
          url: '/act/clock/webpunchs',
          data: list,
          msg: '考勤打卡成功'
        },
        { root: true }
      )
      return res
    },
    // 后台修改出勤情况
    async editAttendance({ dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'PUT',
          url: '/act/clock/invalid',
          data: data,
          msg: '修改考勤成功'
        },
        { root: true }
      )
      return res
    },
    // 查询人员某月考勤是否确认
    async getAttendanceIsSure({ dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        { method: 'GET', url: '/query/laborclock/isConfmonthtime', data: data },
        { root: true }
      )
      if (!res || res.data == null) return res
      return Object.assign({}, res, {
        data: normalizeConfirmationCount(res.data)
      })
    },
    // 退场办理：管理员确认指定人员某月考勤（无需短信）
    async webAgreeClock({ dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'PUT',
          url: '/act/clock/webagree',
          data: data,
          msg: '确认考勤成功'
        },
        { root: true }
      )
      return res
    },
    // 查询考勤日历明细，并同步该月确认状态
    async getAttendance({ rootState, commit, dispatch }) {
      commit(
        'baseSet',
        { module: 'attendance', key: 'attendanceIsSure', value: '未确认' },
        { root: true }
      )
      if (rootState.currentTab.label === '劳务考勤') {
        await dispatch(
          'bidSection/ensureDefaultBidQuery',
          { queryKey: 'laborAttendance', fieldKey: 'upVproUid' },
          { root: true }
        )
      } else if (rootState.currentTab.label === '管理考勤') {
        await dispatch(
          'bidSection/ensureDefaultBidQuery',
          { queryKey: 'manageAttendance', fieldKey: 'upVproUid' },
          { root: true }
        )
      }
      if (
        rootState.currentTab.label === '劳务考勤' &&
        !rootState.queryValues.laborAttendance.personUid
      ) {
        if (!rootState.queryValues.laborAttendance.downVproUid) {
          commit(
            'baseSet',
            {
              module: 'attendance',
              key: 'statisticsType',
              value: 'bidSection'
            },
            { root: true }
          )
        } else {
          commit(
            'baseSet',
            {
              module: 'attendance',
              key: 'statisticsType',
              value: 'laborCompany'
            },
            { root: true }
          )
          const data = {
            orgUid: resolveConfOrgUid(
              rootState.queryValues.laborAttendance,
              rootState.queryValues.laborAttendance.downVproUid
            ),
            date: rootState.queryValues.laborAttendance.monthTime
          }
          await dispatch('getOrgAttendanceIsSure', data)
        }
        await dispatch('getLaborOrgAttendance')
      } else if (
        rootState.currentTab.label === '劳务考勤' &&
        rootState.queryValues.laborAttendance.personUid
      ) {
        commit(
          'baseSet',
          { module: 'attendance', key: 'statisticsType', value: 'person' },
          { root: true }
        )
        const qv = rootState.queryValues.laborAttendance
        const personUid = resolvePersonFilterUid(qv.personUid)
        const isConf = await dispatch('getAttendanceIsSure', {
          personUid,
          monthTime: qv.monthTime,
          orgUid: resolveConfOrgUid(qv, qv.downVproUid)
        })
        commit(
          'baseSet',
          {
            module: 'attendance',
            key: 'attendanceIsSure',
            value:
              isConf && Number(isConf.data) > 0 ? '已确认' : '未确认'
          },
          { root: true }
        )
        await dispatch('getLaborPerAttendance')
      } else if (
        rootState.currentTab.label === '管理考勤' &&
        !rootState.queryValues.manageAttendance.personUid
      ) {
        commit(
          'baseSet',
          { module: 'attendance', key: 'statisticsType', value: 'organ' },
          { root: true }
        )
        const data = {
          orgUid: resolveConfOrgUid(
            rootState.queryValues.manageAttendance,
            rootState.queryValues.manageAttendance.upVproUid
          ),
          date: rootState.queryValues.manageAttendance.monthTime
        }
        await dispatch('getOrgAttendanceIsSure', data)
        await dispatch('getManageOrgAttendance')
      } else if (
        rootState.currentTab.label === '管理考勤' &&
        rootState.queryValues.manageAttendance.personUid
      ) {
        commit(
          'baseSet',
          { module: 'attendance', key: 'statisticsType', value: 'person' },
          { root: true }
        )
        const qv = rootState.queryValues.manageAttendance
        const isConf = await dispatch('getAttendanceIsSure', {
          personUid: resolvePersonFilterUid(qv.personUid),
          monthTime: qv.monthTime,
          orgUid: resolveConfOrgUid(qv, qv.upVproUid)
        })
        commit(
          'baseSet',
          {
            module: 'attendance',
            key: 'attendanceIsSure',
            value:
              isConf && Number(isConf.data) > 0 ? '已确认' : '未确认'
          },
          { root: true }
        )
        await dispatch('getManagePerAttendance')
      }
    },
    // 获取某劳务机构某月每天考勤明细(劳务机构考勤日历)
    async getLaborOrgAttendance({ rootState, commit, dispatch }) {
      var queryValues = rootState.queryValues.laborAttendance
      queryValues = removeNull(queryValues)
      const res = await dispatch(
        'baseRequest',
        {
          method: 'GET',
          url: '/query/laborclock/monthorgannum',
          data: queryValues
        },
        { root: true }
      )
      if (res.data) {
        commit(
          'baseSet',
          { module: 'attendance', key: 'orgAttendance', value: res.data },
          { root: true }
        )
      } else {
        commit(
          'baseSet',
          { module: 'attendance', key: 'orgAttendance', value: [] },
          { root: true }
        )
      }
    },
    // 获取某管理机构某月每天考勤明细(管理机构考勤日历)
    async getManageOrgAttendance({ rootState, commit, dispatch }) {
      var queryValues = rootState.queryValues.manageAttendance
      queryValues = removeNull(queryValues)
      const res = await dispatch(
        'baseRequest',
        {
          method: 'GET',
          url: '/query/adminclock/monthorgannum',
          data: queryValues
        },
        { root: true }
      )
      if (res.data) {
        commit(
          'baseSet',
          { module: 'attendance', key: 'orgAttendance', value: res.data },
          { root: true }
        )
      } else {
        commit(
          'baseSet',
          { module: 'attendance', key: 'orgAttendance', value: [] },
          { root: true }
        )
      }
    },
    // 获取某劳务公司某人员某月每天考勤明细(劳务人员考勤日历)
    async getLaborPerAttendance({ rootState, commit, dispatch }) {
      var queryValues = normalizePersonQuery(
        rootState.queryValues.laborAttendance
      )
      queryValues = removeNull(queryValues)
      const res = await dispatch(
        'baseRequest',
        {
          method: 'GET',
          url: '/query/laborclock/monthlabornum',
          data: queryValues
        },
        { root: true }
      )
      if (res.data) {
        commit(
          'baseSet',
          { module: 'attendance', key: 'perAttendance', value: res.data },
          { root: true }
        )
      } else {
        commit(
          'baseSet',
          { module: 'attendance', key: 'perAttendance', value: [] },
          { root: true }
        )
      }
    },
    // 获取某管理机构某人员某月每天考勤明细(管理人员考勤日历)
    async getManagePerAttendance({ rootState, commit, dispatch }) {
      var queryValues = normalizePersonQuery(
        rootState.queryValues.manageAttendance
      )
      queryValues = removeNull(queryValues)
      const res = await dispatch(
        'baseRequest',
        {
          method: 'GET',
          url: '/query/adminclock/monthlabornum',
          data: queryValues
        },
        { root: true }
      )
      if (res.data) {
        commit(
          'baseSet',
          { module: 'attendance', key: 'perAttendance', value: res.data },
          { root: true }
        )
      } else {
        commit(
          'baseSet',
          { module: 'attendance', key: 'perAttendance', value: [] },
          { root: true }
        )
      }
    },
    // 获取某劳务人员某月考勤统计（退场办理等）
    async getLaborPerMonthStatistics({ rootState, commit, dispatch }) {
      var queryValues = normalizePersonQuery(
        rootState.queryValues.laborAttendance
      )
      queryValues = removeNull(queryValues)
      const res = await dispatch(
        'baseRequest',
        {
          method: 'GET',
          url: '/query/laborclock/totallabormonth',
          data: queryValues
        },
        { root: true }
      )
      if (res.data) {
        commit(
          'baseSet',
          { module: 'attendance', key: 'perMonthStatistics', value: res.data },
          { root: true }
        )
      } else {
        commit(
          'baseSet',
          { module: 'attendance', key: 'perMonthStatistics', value: {} },
          { root: true }
        )
      }
    },
    // 获取某劳务人员累计考勤统计（退场办理等）
    async getLaborPerTotalStatistics({ rootState, commit, dispatch }) {
      var queryValues = normalizePersonQuery(
        rootState.queryValues.laborAttendance
      )
      queryValues = removeNull(queryValues)
      const res = await dispatch(
        'baseRequest',
        {
          method: 'GET',
          url: '/query/laborclock/alllabornum',
          data: queryValues
        },
        { root: true }
      )
      if (res.data) {
        commit(
          'baseSet',
          { module: 'attendance', key: 'perTotalStatistics', value: res.data },
          { root: true }
        )
      } else {
        commit(
          'baseSet',
          { module: 'attendance', key: 'perTotalStatistics', value: {} },
          { root: true }
        )
      }
    },
    // 获取项目标段某天劳务公司出勤情况
    async getLaborOrgDayAttendance({ rootState, commit, dispatch }, data) {
      var queryValues = {}
      queryValues.organUid = data
        ? data.organUid
        : rootState.queryValues.laborAttendance.organUid
      queryValues.upVproUid = data
        ? data.upVproUid
        : rootState.queryValues.laborAttendance.upVproUid
      queryValues.monthTime = data ? data.day : rootState.isSelectedDay
      queryValues = removeNull(queryValues)
      const res = await dispatch(
        'baseRequest',
        {
          method: 'GET',
          url: '/query/laborclock/orderlaborlist',
          data: queryValues
        },
        { root: true }
      )
      const obj = {
        uid: 'vProjectUid',
        label: 'vProjectName',
        childUid: 'laborTeamUid',
        childLabel: 'laborTeamName',
        sumKeys: ['shouldNum', 'actualNum', 'ownNum']
      }
      var orgDayAttendance = res.data ? getLevelArray(res.data, obj) : []
      for (var i = 0; i < orgDayAttendance.length; i++) {
        if (orgDayAttendance[i].shouldNum) {
          orgDayAttendance[i].totalLock = (
            (orgDayAttendance[i].actualNum / orgDayAttendance[i].shouldNum) *
            100
          ).toFixed(1)
          orgDayAttendance[i].showButtons = false
          orgDayAttendance[i].day = queryValues.monthTime
          orgDayAttendance[i].children.forEach((item) => {
            item.day = queryValues.monthTime
            if (item.ownNum === 0) {
              item.disabledButtons = [0]
            }
          })
        }
      }
      commit(
        'baseSet',
        {
          module: 'attendance',
          key: 'orgDayAttendance',
          value: orgDayAttendance
        },
        { root: true }
      )
      return orgDayAttendance
    },
    // 获取某天缺勤人员名单
    async getOrgDayAbsent({ rootState, commit, dispatch }, data) {
      var queryValues = {}
      const isLabor = rootState.currentTab.label === '劳务考勤'
      if (rootState.currentTab.label === '管理考勤') {
        queryValues.upVproUid = data
          ? data.upVproUid
            ? data.upVproUid
            : data.uid
          : rootState.queryValues.manageAttendance.upVproUid
      } else if (isLabor) {
        queryValues.downVproUid = data
          ? data.downVproUid
            ? data.downVproUid
            : data.uid
          : rootState.queryValues.laborAttendance.downVproUid
      }
      // laborclocklist 用当日；isConfmonthtime 必须用 yyyy-MM
      const day = data && data.day ? data.day : rootState.isSelectedDay
      queryValues.monthTime = day
      const monthKey = isLabor ? 'laborAttendance' : 'manageAttendance'
      const monthFromQuery =
        rootState.queryValues[monthKey] &&
        rootState.queryValues[monthKey].monthTime
      const monthForConf =
        monthFromQuery ||
        (day && String(day).length >= 7 ? String(day).slice(0, 7) : '')
      commit(
        'baseSet',
        { module: 'attendance', key: 'orgDayAbsent', value: [] },
        { root: true }
      )
      const res = await dispatch(
        'baseRequest',
        {
          method: 'GET',
          url: '/query/laborclock/laborclocklist',
          data: queryValues
        },
        { root: true }
      )
      var orgDayAbsent = res.data ? res.data : []
      if (!orgDayAbsent.length) {
        return
      }
      for (let index = 0; index < orgDayAbsent.length; index++) {
        const item = orgDayAbsent[index]
        item.isClock = '缺勤'
        let params = {}
        params.personUid = item.personUid
        params.monthTime = monthForConf
        const qv = rootState.queryValues[monthKey] || {}
        params.orgUid = resolveConfOrgUid(
          qv,
          isLabor ? queryValues.downVproUid : queryValues.upVproUid
        )
        const isConf = await dispatch('getAttendanceIsSure', params)
        if (isConf && Number(isConf.data) > 0) {
          item.isConf = '已确认'
        } else if (isConf && Number(isConf.data) === 0) {
          item.isConf = '未确认'
        } else {
          item.isConf = '未知'
        }
      }
      orgDayAbsent = orgDayAbsent.sort(sortBy(['isConf']))
      commit(
        'baseSet',
        {
          module: 'attendance',
          key: 'orgDayAbsent',
          value: orgDayAbsent
        },
        { root: true }
      )
    }
  }
}
